import { render, staticRenderFns } from "./InvestorOnboardingNameAddress.vue?vue&type=template&id=0e2522c0&"
import script from "./InvestorOnboardingNameAddress.vue?vue&type=script&lang=js&"
export * from "./InvestorOnboardingNameAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports